<template>
    <div class="id-finder-container">
        <div class="site-id-header">
            <div class="search-section">
                <a-input-search
                    v-model="searchQuery"
                    placeholder="ID veya isim ile arama yapın"
                    @search="handleSearch"
                    enterButton
                    allowClear
                    class="search-input"
                />
            </div>
            <div class="site-id-container">
                <span class="site-id-label">{{ $t('auto.iDFinderSiteId') }}</span>
                <div class="site-id-value" @click="copyToClipboard($store.state.site.site._id)">
                    {{ $store.state.site.site._id }}
                    <a-icon type="copy" />
                </div>
            </div>
        </div>

        <div class="id-finder-content">
            <div class="sidebar-menu">
                <div class="menu-items">
                    <div class="menu-item" :class="{ active: activeTab === 'users' }" @click="handleTabChange('users')">
                        <i class="material-icons menu-icon" style="color: #1890ff">people</i>
                        <span>{{ $t('auto.iDFinderUsers') }}</span>
                    </div>

                    <div class="menu-item" :class="{ active: activeTab === 'tags' }" @click="handleTabChange('tags')">
                        <i class="material-icons menu-icon" style="color: #52c41a">local_offer</i>
                        <span>{{ $t('auto.iDFinderEtiketler') }}</span>
                    </div>

                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'tasktags' }"
                        @click="handleTabChange('tasktags')"
                    >
                        <i class="material-icons menu-icon" style="color: #fe6244">local_offer</i>
                        <span>{{ $t('auto.iDFinderTaskEtiketleri') }}</span>
                    </div>

                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'departments' }"
                        @click="handleTabChange('departments')"
                    >
                        <i class="material-icons menu-icon" style="color: #722ed1">business</i>
                        <span>{{ $t('auto.iDFinderDepartmanlar') }}</span>
                    </div>

                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'workflows' }"
                        @click="handleTabChange('workflows')"
                    >
                        <i class="material-icons menu-icon" style="color: #fa8c16">assignment</i>
                        <span>{{ $t('auto.iDFinderTaskWorkflows') }}</span>
                    </div>

                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'pipelines' }"
                        @click="handleTabChange('pipelines')"
                    >
                        <i class="material-icons menu-icon" style="color: #13c2c2">view_column</i>
                        <span>{{ $t('auto.iDFinderPipelineStages') }}</span>
                    </div>

                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'automations' }"
                        @click="handleTabChange('automations')"
                    >
                        <i class="material-icons menu-icon" style="color: #eb2f96">smart_toy</i>
                        <span>{{ $t('auto.iDFinderOtomasyonlar') }}</span>
                    </div>

                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'chatbots' }"
                        @click="handleTabChange('chatbots')"
                    >
                        <i class="material-icons menu-icon" style="color: #f5222d">chat</i>
                        <span>{{ $t('auto.iDFinderChatbotScenarios') }}</span>
                    </div>

                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'channels' }"
                        @click="handleTabChange('channels')"
                    >
                        <i class="material-icons menu-icon" style="color: #1890ff">settings_input_component</i>
                        <span>{{ $t('auto.iDFinderKanallar') }}</span>
                    </div>

                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'whatsapp' }"
                        @click="handleTabChange('whatsapp')"
                    >
                        <i class="material-icons menu-icon" style="color: #52c41a">message</i>
                        <span>{{ $t('auto.iDFinderWhatsAppTemplates') }}</span>
                    </div>

                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'voiceAgents' }"
                        @click="handleTabChange('voiceAgents')"
                    >
                        <i class="material-icons menu-icon" style="color: #faad14">record_voice_over</i>
                        <span>{{ $t('auto.iDFinderVoiceAgents') }}</span>
                    </div>
                    <div class="menu-item" :class="{ active: activeTab === 'form' }" @click="handleTabChange('form')">
                        <i class="material-icons menu-icon" style="color: #9932cc"> assignment </i>
                        <span>{{ $t('auto.iDFinderForm') }}</span>
                    </div>
                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'calendar' }"
                        @click="handleTabChange('calendar')"
                    >
                        <i class="material-icons menu-icon" style="color: #00b894"> calendar_today </i>
                        <span>{{ $t('auto.iDFinderTakvim') }}</span>
                    </div>
                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'tables' }"
                        @click="handleTabChange('tables')"
                    >
                        <i class="material-icons menu-icon" style="color: #ff6b6b"> table_chart </i>
                        <span>{{ $t('auto.iDFinderTablolar') }}</span>
                    </div>
                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'table-fields' }"
                        @click="handleTabChange('table-fields')"
                    >
                        <i class="material-icons menu-icon" style="color: #4ecdc4"> view_column </i>
                        <span>{{ $t('auto.iDFinderTableFields') }}</span>
                    </div>
                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'modules' }"
                        @click="handleTabChange('modules')"
                    >
                        <i class="material-icons menu-icon" style="color: #95e1d3"> view_module </i>
                        <span>{{ $t('auto.iDFinderModules') }}</span>
                    </div>
                    <div
                        class="menu-item"
                        :class="{ active: activeTab === 'languages' }"
                        @click="handleTabChange('languages')"
                    >
                        <i class="material-icons menu-icon" style="color: #2f54eb"> language </i>
                        <span>{{ $t('auto.iDFinderLanguages') }}</span>
                    </div>
                </div>
            </div>

            <div class="content-area">
                <div class="tab-content">
                    <!-- Users Tab Content -->
                    <div v-if="activeTab === 'users'" class="table-container">
                        <a-table
                            :columns="userColumns"
                            :data-source="filteredUsers"
                            :loading="loading.users"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" /> {{ $t('auto.iDFinderKopyala') }}
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Tags Tab Content -->
                    <div v-if="activeTab === 'tags'" class="table-container">
                        <a-table
                            :columns="tagColumns"
                            :data-source="filteredTags"
                            :loading="loading.tags"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="color" slot-scope="color">
                                <div class="color-indicator" :style="{ backgroundColor: color }"></div>
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" /> Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Task Tags Tab Content -->
                    <div v-if="activeTab === 'tasktags'" class="table-container">
                        <a-table
                            :columns="tagColumns"
                            :data-source="filteredTags"
                            :loading="loading.tags"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="color" slot-scope="color">
                                <div class="color-indicator" :style="{ backgroundColor: color }"></div>
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" />
                                    Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Departments Tab Content -->
                    <div v-if="activeTab === 'departments'" class="table-container">
                        <a-table
                            :columns="departmentColumns"
                            :data-source="filteredDepartments"
                            :loading="loading.departments"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="name" slot-scope="text, record">
                                {{ getDepartmentName(record) }}
                            </template>
                            <template slot="status" slot-scope="status">
                                <a-badge :status="status ? 'success' : 'error'" :text="status ? 'Aktif' : 'Pasif'" />
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" /> Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Workflows Tab Content -->
                    <div v-if="activeTab === 'workflows'" class="table-container">
                        <a-table
                            :columns="workflowColumns"
                            :data-source="filteredWorkflows"
                            :loading="loading.workflows"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" /> Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Pipelines Tab Content -->
                    <div v-if="activeTab === 'pipelines'" class="table-container">
                        <a-table
                            :columns="pipelineColumns"
                            :data-source="filteredPipelines"
                            :loading="loading.pipelines"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="color" slot-scope="color">
                                <div class="color-indicator" :style="{ backgroundColor: color || '#cccccc' }"></div>
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" /> Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Automations Tab Content -->
                    <div v-if="activeTab === 'automations'" class="table-container">
                        <a-table
                            :columns="automationColumns"
                            :data-source="filteredAutomations"
                            :loading="loading.automations"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="trigger" slot-scope="text, record">
                                <a-tag :color="getAutomationTriggerColor($_.get(record.options, 'trigger'))">
                                    {{ getAutomationTriggerText($_.get(record.options, "trigger")) }}
                                </a-tag>
                            </template>
                            <template slot="published" slot-scope="published">
                                <a-badge
                                    :status="published ? 'success' : 'error'"
                                    :text="published ? 'Yayında' : 'Yayında Değil'"
                                />
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" /> Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Chatbots Tab Content -->
                    <div v-if="activeTab === 'chatbots'" class="table-container">
                        <a-table
                            :columns="chatbotColumns"
                            :data-source="filteredChatbots"
                            :loading="loading.chatbots"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="integrations" slot-scope="text, record">
                                <div class="integration-tags">
                                    <a-tag v-if="$_.get(record.integrations, 'supsisWidget')" color="blue"
                                        >Widget</a-tag
                                    >
                                    <a-tag v-if="$_.get(record.integrations, 'whatsapp')" color="green">WhatsApp</a-tag>
                                    <a-tag v-if="$_.get(record.integrations, 'whatsappBusiness')" color="green"
                                        >WhatsApp Business</a-tag
                                    >
                                    <a-tag v-if="$_.get(record.integrations, 'instagram')" color="purple"
                                        >Instagram</a-tag
                                    >
                                    <a-tag v-if="$_.get(record.integrations, 'telegram')" color="#0088cc"
                                        >Telegram</a-tag
                                    >
                                </div>
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" /> Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Channels Tab Content -->
                    <div v-if="activeTab === 'channels'" class="table-container">
                        <a-table
                            :columns="channelColumns"
                            :data-source="filteredChannels"
                            :loading="loading.channels"
                            :pagination="{ pageSize: 30 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="channelType" slot-scope="text, record">
                                <span>{{ record.type }}</span>
                                <a-tag v-if="record.type === 'openrouter' && $_.get(record, 'payload.provider')" color="purple" style="margin-left: 5px;">
                                    {{ getOpenRouterProviderName($_.get(record, 'payload.provider')) }}
                                </a-tag>
                            </template>
                            <template slot="channelAction" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" /> Kopyala
                                </a-button>
                                <a-button
                                    v-if="record.type === 'openrouter'"
                                    type="default"
                                    size="small"
                                    style="margin-left: 8px;"
                                    @click="openOpenRouterModelsModal(record)"
                                    :loading="loadingModelsChannelId === record._id"
                                >
                                    <a-icon type="unordered-list" /> Modeller
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Whatsapp Tab Content -->
                    <div v-if="activeTab === 'whatsapp'" class="table-container">
                        <div class="whatsapp-filter">
                            <a-select
                                v-model="selectedChannel"
                                placeholder="Whatsapp Business API kanalı seçin"
                                class="channel-select"
                                @change="loadWhatsappTemplates"
                            >
                                <a-select-option
                                    v-for="channel in whatsappChannels"
                                    :key="channel._id"
                                    :value="channel._id"
                                >
                                    {{ channel.name }}
                                </a-select-option>
                            </a-select>
                        </div>
                        <a-table
                            :columns="whatsappColumns"
                            :data-source="filteredWhatsappTemplates"
                            :loading="loading.whatsapp"
                            :pagination="{ pageSize: 30 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="id"
                        >
                            <template slot="whatsappName" slot-scope="text, record">
                                {{ getFormattedWhatsappTemplate(record).name }}
                            </template>
                            <template slot="whatsappLanguage" slot-scope="text, record">
                                {{ getFormattedWhatsappTemplate(record).language }}
                            </template>
                            <template slot="status" slot-scope="status">
                                <a-badge :status="getStatusType(status)" :text="getStatusText(status)" />
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record.id)">
                                    <a-icon type="copy" /> Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Voice Agents Tab Content -->
                    <div v-if="activeTab === 'voiceAgents'" class="table-container">
                        <a-table
                            :columns="voiceAgentColumns"
                            :data-source="filteredVoiceAgents"
                            :loading="loading.voiceAgents"
                            :pagination="{ pageSize: 30 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="agent_id"
                        >
                            <template slot="type" slot-scope="text, record">
                                {{ getVoiceAgentType(record) }}
                            </template>
                            <template slot="agentType" slot-scope="text, record">
                                {{ getVoiceAgentPromptType(record) }}
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record.agent_id)">
                                    <a-icon type="copy" /> Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Form Tab Content -->
                    <div v-if="activeTab === 'form'" class="table-container">
                        <a-table
                            :columns="formColumns"
                            :data-source="filteredForms"
                            :loading="loading.forms"
                            :pagination="{ pageSize: 30 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" />
                                    Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Calendar Tab Content -->
                    <div v-if="activeTab === 'calendar'" class="table-container">
                        <a-table
                            :columns="calendarColumns"
                            :data-source="filteredCalendars"
                            :loading="loading.calendars"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="color" slot-scope="color">
                                <div class="color-indicator" :style="{ backgroundColor: color }"></div>
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" />
                                    Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Tables Tab Content -->
                    <div v-if="activeTab === 'tables'" class="table-container">
                        <a-table
                            :columns="tableColumns"
                            :data-source="filteredTables"
                            :loading="loading.tables"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" />
                                    Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Table Fields Tab Content -->
                    <div v-if="activeTab === 'table-fields'" class="table-container">
                        <div class="table-field-filter">
                            <a-select
                                v-model="selectedTable"
                                placeholder="Tablo seçin"
                                class="table-select"
                                @change="handleTableChange"
                                show-search
                                :filter-option="filterTableOption"
                            >
                                <a-select-option v-for="table in tables" :key="table._id" :value="table._id">
                                    {{ table.name }}
                                </a-select-option>
                            </a-select>
                        </div>
                        <a-table
                            :columns="tableFieldColumns"
                            :data-source="filteredTableFields"
                            :loading="loading.tableFields"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" />
                                    Kopyala
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Modules Tab Content -->
                    <div v-if="activeTab === 'modules'" class="table-container">
                        <a-table
                            :columns="moduleColumns"
                            :data-source="filteredModules"
                            :loading="loading.modules"
                            :pagination="{ pageSize: 10 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="_id"
                        >
                            <template slot="action" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record._id)">
                                    <a-icon type="copy" />
                                    Kopyala
                                </a-button>
                                <a-button
                                    v-if="record.type === 'module'"
                                    type="default"
                                    size="small"
                                    style="margin-left: 8px;"
                                    @click="openModuleApiDoc(record)"
                                >
                                    <a-icon type="file-text" />
                                    API Doc
                                </a-button>
                            </template>
                        </a-table>
                    </div>

                    <!-- Dil kodları (languages.json) -->
                    <div v-if="activeTab === 'languages'" class="table-container">
                        <a-table
                            :columns="languageColumns"
                            :data-source="filteredLanguages"
                            :pagination="{ pageSize: 15 }"
                            :scroll="{ y: tableHeight }"
                            size="middle"
                            row-key="code"
                        >
                            <template slot="langAction" slot-scope="text, record">
                                <a-button type="primary" size="small" @click="copyToClipboard(record.code)">
                                    <a-icon type="copy" />
                                    {{ $t('auto.iDFinderKopyala') }}
                                </a-button>
                            </template>
                        </a-table>
                    </div>
                </div>
            </div>
        </div>

        <!-- OpenRouter Models Modal -->
        <a-modal
            v-model="openRouterModelsModal"
            :title="openRouterModelsChannel ? `${openRouterModelsChannel.name} - Model Listesi` : 'Model Listesi'"
            width="900px"
            :footer="null"
        >
            <div class="openrouter-models-modal">
                <div class="models-info" v-if="openRouterModelsChannel">
                    <a-tag color="purple">
                        {{ getOpenRouterProviderName($_.get(openRouterModelsChannel, 'payload.provider', 'openrouter')) }}
                    </a-tag>
                    <span class="models-count">{{ openRouterModels.length }} model bulundu</span>
                </div>
                <a-table
                    :columns="[
                        { title: 'Model ID', dataIndex: 'id', key: 'id', width: '300px', ellipsis: true },
                        { title: 'İsim', dataIndex: 'name', key: 'name', ellipsis: true },
                        { title: 'Context', dataIndex: 'context_length', key: 'context_length', width: '100px' },
                        { title: 'İşlem', key: 'action', scopedSlots: { customRender: 'modelAction' }, width: '100px' },
                    ]"
                    :data-source="openRouterModels"
                    :pagination="{ pageSize: 10 }"
                    :scroll="{ y: 400 }"
                    size="small"
                    row-key="id"
                >
                    <template slot="modelAction" slot-scope="text, record">
                        <a-button type="primary" size="small" @click="copyModelId(record.id)">
                            <a-icon type="copy" />
                        </a-button>
                    </template>
                </a-table>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { VOICE_AGENT_API } from "../../../../api/voiceAgent";
import _ from "lodash";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import languagesCatalog from "../../../../language/languages.json";

export default {
    name: "IDFinder",
    data() {
        return {
            searchQuery: "",
            selectedType: "all",
            activeTab: "users",
            selectedChannel: null,
            whatsappTemplates: [],
            voiceAgents: [],
            calendars: [],
            selectedTable: null,
            tableFields: [],
            tableHeight: 500,
            loadingModelsChannelId: null,
            openRouterModelsModal: false,
            openRouterModels: [],
            openRouterModelsChannel: null,
            loading: {
                users: false,
                tags: false,
                departments: false,
                workflows: false,
                pipelines: false,
                automations: false,
                chatbots: false,
                channels: false,
                whatsapp: false,
                voiceAgents: false,
                forms: false,
                calendars: false,
                tables: false,
                tableFields: false,
                modules: false,
            },
            // Tab Seçenekleri
            tabOptions: [
                { key: "users", title: "Kullanıcılar" },
                { key: "tags", title: "Etiketler" },
                { key: "departments", title: "Departmanlar" },
                { key: "workflows", title: "Görev Süreçleri" },
                { key: "pipelines", title: "Pipeline Aşamaları" },
                { key: "automations", title: "Otomasyonlar" },
                { key: "chatbots", title: "Chatbot Senaryoları" },
                { key: "channels", title: "Kanallar" },
                { key: "whatsapp", title: "Whatsapp Şablonları" },
                { key: "voiceAgents", title: "Ses Ajanları" },
                { key: "form", title: "Form" },
                { key: "calendar", title: "Takvim" },
                { key: "tables", title: "Tablolar" },
                { key: "table-fields", title: "Tablo Field'ları" },
                { key: "modules", title: "Modüller" },
                { key: "languages", title: "Dil kodları" },
            ],
            // Tablo sütun tanımları
            userColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "İsim", dataIndex: "name", key: "name" },
                { title: "Email", dataIndex: "email", key: "email" },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            departmentColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "İsim", key: "name", scopedSlots: { customRender: "name" } },
                { title: "Durum", dataIndex: "isActive", key: "status", scopedSlots: { customRender: "status" } },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            tagColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "İsim", dataIndex: "name", key: "name" },
                {
                    title: "Renk",
                    dataIndex: "color",
                    key: "color",
                    scopedSlots: { customRender: "color" },
                    width: "80px",
                },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            workflowColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "Başlık", dataIndex: "title", key: "title" },
                { title: "Açıklama", dataIndex: "description", key: "description", ellipsis: true },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            pipelineColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "İsim", dataIndex: "name", key: "name" },
                { title: "Workflow", dataIndex: "workflowTitle", key: "workflowTitle" },
                { title: "Tip", dataIndex: "type", key: "type" },
                {
                    title: "Renk",
                    dataIndex: "color",
                    key: "color",
                    scopedSlots: { customRender: "color" },
                    width: "80px",
                },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            channelColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "İsim", dataIndex: "name", key: "name" },
                { title: "Tip", dataIndex: "type", key: "type", scopedSlots: { customRender: "channelType" } },
                {
                    title: "Durum",
                    dataIndex: "enabled",
                    key: "enabled",
                    customRender: (enabled) => (enabled ? "Aktif" : "Pasif"),
                },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "channelAction" }, width: "200px" },
            ],
            automationColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "İsim", dataIndex: "name", key: "name" },
                { title: "Tetikleyici", key: "trigger", scopedSlots: { customRender: "trigger" } },
                {
                    title: "Durum",
                    dataIndex: "published",
                    key: "published",
                    scopedSlots: { customRender: "published" },
                },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            chatbotColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "Başlık", dataIndex: "title", key: "title" },
                { title: "Açıklama", dataIndex: "description", key: "description", ellipsis: true },
                { title: "Entegrasyonlar", key: "integrations", scopedSlots: { customRender: "integrations" } },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            whatsappColumns: [
                { title: "ID", dataIndex: "id", key: "id", width: "280px", ellipsis: true },
                { title: "İsim", key: "name", scopedSlots: { customRender: "whatsappName" } },
                { title: "Kategori", dataIndex: "category", key: "category" },
                { title: "Dil", key: "language", scopedSlots: { customRender: "whatsappLanguage" } },
                { title: "Durum", dataIndex: "status", key: "status", scopedSlots: { customRender: "status" } },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            voiceAgentColumns: [
                { title: "ID", dataIndex: "agent_id", key: "agent_id", width: "280px", ellipsis: true },
                { title: "İsim", dataIndex: "agent_name", key: "agent_name" },
                { title: "Türü", key: "type", scopedSlots: { customRender: "type" } },
                { title: "Ajan Tipi", key: "agentType", scopedSlots: { customRender: "agentType" } },
                { title: "Ses", dataIndex: "voice.voice_name", key: "voice" },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            formColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "Başlık", dataIndex: "title", key: "title" },
                { title: "Görüntülenme", dataIndex: "formViews", key: "formViews" },
                {
                    title: "Oluşturulma Tarihi",
                    dataIndex: "createdAt",
                    key: "createdAt",
                    customRender: (text) => this.$moment(text).format("DD.MM.YYYY HH:mm"),
                },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            calendarColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "Başlık", dataIndex: "summary", key: "summary" },
                { title: "Açıklama", dataIndex: "description", key: "description" },
                { title: "Oluşturan", dataIndex: "userId.name", key: "userId" },
                { title: "Tip", dataIndex: "type", key: "type" },
                {
                    title: "Renk",
                    dataIndex: "color",
                    key: "color",
                    scopedSlots: { customRender: "color" },
                    width: "80px",
                },
                {
                    title: "Oluşturulma Tarihi",
                    dataIndex: "createdAt",
                    key: "createdAt",
                    customRender: (text) => this.$moment(text).format("DD.MM.YYYY HH:mm"),
                },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            tableColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "İsim", dataIndex: "name", key: "name" },
                { title: "Açıklama", dataIndex: "description", key: "description", ellipsis: true },
                {
                    title: "Oluşturulma Tarihi",
                    dataIndex: "createdAt",
                    key: "createdAt",
                    customRender: (text) => this.$moment(text).format("DD.MM.YYYY HH:mm"),
                },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            tableFieldColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "Label", dataIndex: "name", key: "name" },
                { title: "API Name", dataIndex: "apiName", key: "apiName" },
                { title: "Field Type", dataIndex: "fieldType", key: "fieldType" },
                { title: "Value Type", dataIndex: "valueType", key: "valueType" },
                { title: "Pozisyon", dataIndex: "position", key: "position", width: "100px" },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            moduleColumns: [
                { title: "ID", dataIndex: "_id", key: "_id", width: "280px", ellipsis: true },
                { title: "İsim", dataIndex: "name", key: "name" },
                { title: "API Name", dataIndex: "apiName", key: "apiName" },
                { title: "Tip", dataIndex: "type", key: "type" },
                {
                    title: "Bağlı Tablo",
                    key: "table",
                    customRender: (text, record) => this.getModuleTableName(record),
                },
                { title: "İşlem", key: "action", scopedSlots: { customRender: "action" }, width: "100px" },
            ],
            languageColumns: [
                { title: "Orijinal ad", dataIndex: "originalName", key: "originalName", ellipsis: true },
                { title: "Etiket", dataIndex: "label", key: "label" },
                { title: "Dil kodu", dataIndex: "code", key: "code", width: "120px" },
                { title: "İşlem", key: "langAction", scopedSlots: { customRender: "langAction" }, width: "120px" },
            ],
        };
    },

    computed: {
        ...mapState({
            users: (state) => _.orderBy(state.user.users.data, ["name"], ["asc"]),
            tags: (state) => state.tag.tags.data,
            departments: (state) => state.subject.subjects.data,
            workflows: (state) => Object.values(state.tasks.workflows),
            channels: (state) => _.orderBy(state.channel.channels, ["type", "name"], ["asc"]),
            automations: (state) => state.automation.automations,
            chatbots: (state) => state.CB.stories,
            forms: (state) => state.forms.forms,
            user: (state) => state.auth.user,
            tables: (state) => state.table.tables,
            modules: (state) => state.module.modules,
            site: (state) => state.site.site,
        }),
        pipelines() {
            // Tüm workflow'ların içindeki pipeline aşamalarını birleştir
            const allPipelines = [];
            this.workflows.forEach((workflow) => {
                if (workflow.pipeline && Array.isArray(workflow.pipeline)) {
                    workflow.pipeline.forEach((pipeline) => {
                        allPipelines.push({
                            ...pipeline,
                            workflowTitle: workflow.title, // Hangi workflow'a ait olduğunu gösterebilmek için
                            workflowId: workflow._id,
                        });
                    });
                }
            });
            return allPipelines;
        },
        // Whatsapp kanalları
        whatsappChannels() {
            return this.channels.filter((channel) => ["whatsapp-business-api", "whatsapp-business-api-supsis"].includes(channel.type)   && !channel.isDeleted);
        },
        // Filtrelenen veriler
        filteredUsers() {
            if (!this.searchQuery) return this.users;
            const query = this.searchQuery.toLowerCase();
            return this.users.filter(
                (user) =>
                    user._id.includes(query) ||
                    (user.name && user.name.toLowerCase().includes(query)) ||
                    (user.email && user.email.toLowerCase().includes(query))
            );
        },
        filteredTags() {
            if (!this.searchQuery) return this.tags;
            const query = this.searchQuery.toLowerCase();
            return this.tags.filter(
                (tag) => tag._id.includes(query) || (tag.name && tag.name.toLowerCase().includes(query))
            );
        },
        filteredDepartments() {
            if (!this.searchQuery) return this.departments?.filter((dept) => !dept.isDeleted) || [];
            const query = this.searchQuery.toLowerCase();
            return (this.departments || [])
                .filter((dept) => !dept.isDeleted)
                .filter(
                    (dept) => dept._id.includes(query) || this.getDepartmentName(dept).toLowerCase().includes(query)
                );
        },
        filteredWorkflows() {
            if (!this.searchQuery) return this.workflows;
            const query = this.searchQuery.toLowerCase();
            return this.workflows.filter(
                (workflow) =>
                    workflow._id.includes(query) ||
                    (workflow.title && workflow.title.toLowerCase().includes(query)) ||
                    (workflow.description && workflow.description.toLowerCase().includes(query))
            );
        },
        filteredPipelines() {
            if (!this.searchQuery) return this.pipelines;
            const query = this.searchQuery.toLowerCase();
            return this.pipelines.filter(
                (pipeline) =>
                    pipeline._id.includes(query) ||
                    (pipeline.name && pipeline.name.toLowerCase().includes(query)) ||
                    (pipeline.type && pipeline.type.toLowerCase().includes(query)) ||
                    (pipeline.workflowTitle && pipeline.workflowTitle.toLowerCase().includes(query))
            );
        },
        filteredChannels() {
            if (!this.searchQuery) return this.channels;
            const query = this.searchQuery.toLowerCase();
            return this.channels.filter(
                (channel) =>
                    channel._id.includes(query) ||
                    (channel.name && channel.name.toLowerCase().includes(query)) ||
                    (channel.type && channel.type.toLowerCase().includes(query))
            );
        },
        filteredAutomations() {
            if (!this.searchQuery) return this.automations?.filter((auto) => !auto.isDeleted) || [];
            const query = this.searchQuery.toLowerCase();
            return (this.automations || [])
                .filter((auto) => !auto.isDeleted)
                .filter((auto) => auto._id.includes(query) || (auto.name && auto.name.toLowerCase().includes(query)));
        },
        filteredChatbots() {
            if (!this.searchQuery) return this.chatbots || [];
            const query = this.searchQuery.toLowerCase();
            return (this.chatbots || []).filter(
                (story) =>
                    story._id?.includes(query) ||
                    (story.title && story.title.toLowerCase().includes(query)) ||
                    (story.description && story.description.toLowerCase().includes(query))
            );
        },
        filteredWhatsappTemplates() {
            if (!this.searchQuery) return this.whatsappTemplates;
            const query = this.searchQuery.toLowerCase();
            return this.whatsappTemplates.filter((template) => {
                const formatted = this.getFormattedWhatsappTemplate(template);
                return (
                    (template.id && template.id.toLowerCase().includes(query)) ||
                    (formatted.name && formatted.name.toLowerCase().includes(query)) ||
                    (template.category && template.category.toLowerCase().includes(query))
                );
            });
        },
        filteredVoiceAgents() {
            if (!this.searchQuery) return this.voiceAgents;
            const query = this.searchQuery.toLowerCase();
            return this.voiceAgents.filter(
                (agent) =>
                    (agent.agent_id && agent.agent_id.includes(query)) ||
                    (agent.agent_name && agent.agent_name.toLowerCase().includes(query)) ||
                    (this.getVoiceAgentType(agent) && this.getVoiceAgentType(agent).toLowerCase().includes(query))
            );
        },
        filteredForms() {
            if (!this.searchQuery) return this.forms;
            const query = this.searchQuery.toLowerCase();
            return this.forms.filter(
                (form) => form._id.includes(query) || (form.title && form.title.toLowerCase().includes(query))
            );
        },
        filteredCalendars() {
            if (!this.searchQuery) return this.calendars;
            const query = this.searchQuery.toLowerCase();
            return this.calendars.filter(
                (calendar) =>
                    calendar._id.includes(query) ||
                    (calendar.summary && calendar.summary.toLowerCase().includes(query)) ||
                    (calendar.description && calendar.description.toLowerCase().includes(query)) ||
                    (calendar.userId && calendar.userId.name && calendar.userId.name.toLowerCase().includes(query))
            );
        },
        filteredTables() {
            if (!this.searchQuery) return this.tables;
            const query = this.searchQuery.toLowerCase();
            return this.tables.filter(
                (table) =>
                    table._id.includes(query) ||
                    (table.name && table.name.toLowerCase().includes(query)) ||
                    (table.description && table.description.toLowerCase().includes(query))
            );
        },
        filteredTableFields() {
            if (!this.searchQuery) return this.tableFields;
            const query = this.searchQuery.toLowerCase();
            return this.tableFields.filter(
                (field) =>
                    field._id.includes(query) ||
                    (field.name && field.name.toLowerCase().includes(query)) ||
                    (field.apiName && field.apiName.toLowerCase().includes(query)) ||
                    (field.fieldType && field.fieldType.toLowerCase().includes(query))
            );
        },
        filteredModules() {
            if (!this.searchQuery) return this.modules;
            const query = this.searchQuery.toLowerCase();
            return this.modules.filter(
                (module) =>
                    module._id.includes(query) ||
                    (module.name && module.name.toLowerCase().includes(query)) ||
                    (module.apiName && module.apiName.toLowerCase().includes(query)) ||
                    (module.type && module.type.toLowerCase().includes(query))
            );
        },
        filteredLanguages() {
            if (!this.searchQuery) return languagesCatalog;
            const query = this.searchQuery.toLowerCase();
            return languagesCatalog.filter(function (lang) {
                return (
                    (lang.code && lang.code.toLowerCase().indexOf(query) !== -1) ||
                    (lang.label && lang.label.toLowerCase().indexOf(query) !== -1) ||
                    (lang.originalName && lang.originalName.toLowerCase().indexOf(query) !== -1)
                );
            });
        },
    },
    methods: {
        ...mapActions({
            getUsers: "user/getUsers",
            getTags: "tag/getTags",
            getSubjects: "subject/getSubjects",
            getWorkflows: "tasks/getWorkflows",
            getChannels: "channel/getChannels",
            getTemplates: "whatsapp/getTemplates",
            getAutomations: "automation/getAutomations",
            getStories: "CB/listStories",
            getCalendarList: "calendar/getCalendarList",
            fetchCustomerTables: "table/fetchCustomerTables",
            syncModules: "module/syncModules",
        }),
        // Arama ve filtreleme işlevleri
        handleSearch() {
            // Arama işlevi burada
        },
        handleTabChange(key) {
            this.activeTab = key;
            // Tab değiştiğinde ilgili türü seç
            switch (key) {
                case "users":
                    this.selectedType = "user";
                    break;
                case "tags":
                    this.selectedType = "tag";
                    this.getTags();
                    break;
                case "tasktags":
                    this.selectedType = "tasktag";
                    this.getTags("task");
                    break;
                case "departments":
                    this.selectedType = "department";
                    break;
                case "workflows":
                    this.selectedType = "workflow";
                    break;
                case "pipelines":
                    this.selectedType = "pipeline";
                    break;
                case "automations":
                    this.selectedType = "automation";
                    break;
                case "chatbots":
                    this.selectedType = "chatbot";
                    break;
                case "channels":
                    this.selectedType = "channel";
                    break;
                case "whatsapp":
                    this.selectedType = "whatsapp";
                    break;
                case "voiceAgents":
                    this.selectedType = "voiceAgent";
                    if (this.site?._id && this.voiceAgents.length === 0) {
                        this.loadVoiceAgents();
                    }
                    break;
                case "form":
                    this.selectedType = "form";
                    break;
                case "calendar":
                    this.selectedType = "calendar";
                    this.getCalendarList({ userId: this.user._id, userName: this.user.name }).then((result) => {
                        this.calendars = result;
                    });
                    break;
                case "tables":
                    this.selectedType = "table";
                    if (this.tables.length === 0) {
                        this.loadTables();
                    }
                    break;
                case "table-fields":
                    this.selectedType = "table-field";
                    if (this.tables.length === 0) {
                        this.loadTables();
                    }
                    break;
                case "modules":
                    this.selectedType = "module";
                    if (this.modules.length === 0) {
                        this.loadModules();
                    }
                    break;
                case "languages":
                    this.selectedType = "language";
                    break;
                default:
                    break;
            }
        },
        async waitForSiteId(maxWaitTime = 15000, checkInterval = 100) {
            if (this.site?._id) {
                return this.site._id;
            }
            
            const startTime = Date.now();
            
            return new Promise((resolve, reject) => {
                const checkSiteId = () => {
                    const siteId = this.site?._id;
                    
                    if (siteId) {
                        resolve(siteId);
                        return;
                    }
                    
                    if (Date.now() - startTime >= maxWaitTime) {
                        reject(new Error("Site ID yüklenemedi. Lütfen sayfayı yenileyin."));
                        return;
                    }
                    
                    setTimeout(checkSiteId, checkInterval);
                };
                
                checkSiteId();
            });
        },
        async loadData() {
            try {
                await this.waitForSiteId();
                
                // Tüm veri tiplerini paralel olarak yükle
                this.loading.users = true;
                this.loading.tags = true;
                this.loading.departments = true;
                this.loading.workflows = true;
                this.loading.pipelines = true;
                this.loading.automations = true;
                this.loading.chatbots = true;
                this.loading.channels = true;
                this.loading.forms = true;
                this.loading.calendars = true;

                await Promise.all([
                    this.getUsers({ perPage: 1000, page: 1 }),
                    this.getSubjects({ perPage: 1000, page: 1 }),
                    this.getWorkflows(),
                    this.getChannels(),
                    this.getAutomations(),
                    this.getStories(),
                ]);

                if (this.activeTab === "tags") {
                    await this.getTags();
                }
            } catch (error) {
                console.error("Veri yüklenirken hata oluştu:", error);
                this.$message.error(error.message || "Veri yüklenirken bir hata oluştu");
            } finally {
                this.loading.users = false;
                this.loading.tags = false;
                this.loading.departments = false;
                this.loading.workflows = false;
                this.loading.pipelines = false;
                this.loading.automations = false;
                this.loading.chatbots = false;
                this.loading.channels = false;
                this.loading.forms = false;
                this.loading.calendars = false;
                this.loading.voiceAgents = false;

                // Bir Whatsapp kanalı varsa otomatik seç
                if (this.whatsappChannels.length > 0) {
                    this.selectedChannel = this.whatsappChannels[0]._id;
                    this.loadWhatsappTemplates();
                }
            }
        },
        async loadWhatsappTemplates() {
            if (!this.selectedChannel) return;

            try {
                this.loading.whatsapp = true;
                const templates = await this.getTemplates(this.selectedChannel);
                this.whatsappTemplates = templates;
            } catch (error) {
                console.error("Whatsapp şablonları yüklenirken hata oluştu:", error);
                this.$message.error("Whatsapp şablonları yüklenirken bir hata oluştu");
            } finally {
                this.loading.whatsapp = false;
            }
        },
        copyToClipboard(text) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    this.$message.success("ID panoya kopyalandı");
                })
                .catch((err) => {
                    console.error("ID kopyalanırken hata oluştu:", err);
                    this.$message.error("ID kopyalanırken bir hata oluştu");
                });
        },
        // WhatsApp şablon formatına göre (meta/gupshup) formatlanmış değerleri döner
        getFormattedWhatsappTemplate(template) {
            if (!template) return { name: "", language: "" };
            const isMetaFormat = template.format === "meta";
            return {
                name: isMetaFormat ? template.name : template.elementName,
                language: isMetaFormat ? template.language : template.languageCode,
            };
        },
        // WhatsApp şablon durumu için helper metotlar
        getStatusType(status) {
            switch (status) {
                case "APPROVED":
                    return "success";
                case "PENDING":
                    return "warning";
                case "REJECTED":
                case "FAILED":
                    return "error";
                default:
                    return "default";
            }
        },
        getStatusText(status) {
            switch (status) {
                case "APPROVED":
                    return "Onaylandı";
                case "PENDING":
                    return "Beklemede";
                case "REJECTED":
                    return "Reddedildi";
                case "FAILED":
                    return "Başarısız";
                default:
                    return status;
            }
        },
        getDepartmentName(department) {
            // Mevcut dilde departman adını göster, yoksa varsayılan dili kullan
            if (!department || !department.languageContent) return "—";

            // Yeni yapı (object olarak)
            if (typeof department.languageContent === "object" && !Array.isArray(department.languageContent)) {
                const currentLang = this.$i18n.locale;
                if (department.languageContent[currentLang] && department.languageContent[currentLang].name) {
                    return department.languageContent[currentLang].name;
                }

                // Mevcut dilde ad yoksa ilk dildeki adı göster
                const firstLang = Object.keys(department.languageContent)[0];
                return department.languageContent[firstLang]?.name || "İsimsiz Departman";
            }

            // Eski yapı (array olarak)
            if (Array.isArray(department.languageContent)) {
                const langItem = department.languageContent.find((item) => item.languageCode === this.$i18n.locale);
                if (langItem && langItem.name) {
                    return langItem.name;
                }

                // Mevcut dilde ad yoksa ilk dildeki adı göster
                return department.languageContent[0]?.name || department.name || "İsimsiz Departman";
            }

            // Hiçbir dilde tanımlanmamışsa eski name alanını kullan
            return department.name || "İsimsiz Departman";
        },
        getAutomationTriggerText(trigger) {
            const triggerMap = {
                timer: "Zamanlayıcı",
                event: "Olay",
                button: "Buton",
                webhook: "Webhook",
                chatbot: "Chatbot",
                "table-button": "Tablo Butonu",
            };
            return triggerMap[trigger] || trigger || "Belirtilmemiş";
        },
        getAutomationTriggerColor(trigger) {
            const colorMap = {
                timer: "blue",
                event: "green",
                button: "purple",
                webhook: "orange",
                chatbot: "cyan",
                "table-button": "magenta",
            };
            return colorMap[trigger] || "default";
        },
        getVoiceAgentType(agent) {
            const type = this.$_.get(agent, "response_engine.type", "-");
            return type.replace("retell-", "supsis-");
        },
        getVoiceAgentPromptType(agent) {
            const states = this.$_.get(agent, "llm.states");
            return Array.isArray(states) ? "Multi Prompt" : "Single Prompt";
        },
        async loadVoiceAgents() {
            if (this.loading.voiceAgents) return;

            try {
                this.loading.voiceAgents = true;
                const agents = await VOICE_AGENT_API.agents.list();
                this.voiceAgents = agents;
            } catch (error) {
                console.error("Ses ajanları yüklenirken hata oluştu:", error);
                this.$message.error("Ses ajanları yüklenirken bir hata oluştu");
            } finally {
                this.loading.voiceAgents = false;
            }
        },
        async loadTables() {
            if (this.loading.tables) return;

            try {
                this.loading.tables = true;
                await this.fetchCustomerTables();
            } catch (error) {
                console.error("Tablolar yüklenirken hata oluştu:", error);
                this.$message.error("Tablolar yüklenirken bir hata oluştu");
            } finally {
                this.loading.tables = false;
            }
        },
        async loadModules() {
            if (this.loading.modules) return;

            try {
                this.loading.modules = true;
                await this.syncModules();
            } catch (error) {
                console.error("Modüller yüklenirken hata oluştu:", error);
                this.$message.error("Modüller yüklenirken bir hata oluştu");
            } finally {
                this.loading.modules = false;
            }
        },
        handleTableChange() {
            if (!this.selectedTable) {
                this.tableFields = [];
                return;
            }

            const table = this.tables.find((t) => t._id === this.selectedTable);
            if (table && table.fields) {
                this.tableFields = table.fields;
            } else {
                this.tableFields = [];
            }
        },
        filterTableOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        getModuleTableName(module) {
            if (!module || !module.relation) return "-";

            let tableId = null;

            if (module.relation.type === "standart-to-table" && module.relation.standartToTable) {
                tableId = this.$_.get(module.relation, "standartToTable.to.table");
            } else if (module.relation.type === "table-to-standart" && module.relation.tableToTable) {
                tableId = this.$_.get(module.relation, "tableToTable.from.table");
            } else if (module.relation.type === "table-to-table" && module.relation.tableToTable) {
                const fromTable = this.$_.get(module.relation, "tableToTable.from.table");
                const toTable = this.$_.get(module.relation, "tableToTable.to.table");
                if (fromTable && toTable) {
                    const fromTableName = this.tables.find((t) => t._id === fromTable)?.name || fromTable;
                    const toTableName = this.tables.find((t) => t._id === toTable)?.name || toTable;
                    return `${fromTableName} → ${toTableName}`;
                }
            }

            if (tableId) {
                const table = this.tables.find((t) => t._id === tableId);
                return table ? table.name : tableId;
            }

            return "-";
        },
        getApiDomain() {
            var domainMap = {
                production: "api.supsis.live",
                stage: "beta-api.supsis.live",
                development: "tablet-api-local.supsis.live",
                dev: "tablet-api-local.supsis.live",
            };
            var env = process.env.ENVIRONMENT || "production";
            return domainMap[env] || "api.supsis.live";
        },
        openModuleApiDoc(module) {
            const apiName = module.apiName || module.moduleName;
            const siteId = this.$store.state.site.site._id;
            const domain = this.getApiDomain();
            const url = "https://" + domain + "/api/module/" + apiName + "/swagger-ui?siteId=" + siteId;
            window.open(url, "_blank");
        },
        getOpenRouterProviderName(provider) {
            const providerNames = {
                openrouter: "OpenRouter",
                openai: "OpenAI",
                google: "Google",
                anthropic: "Anthropic",
                mistral: "Mistral",
                azure: "Azure",
                bedrock: "Bedrock",
                cohere: "Cohere",
                xai: "xAI",
                deepinfra: "DeepInfra",
                together: "Together",
                fireworks: "Fireworks",
                siliconflow: "SiliconFlow",
                parasail: "Parasail",
                nebius: "Nebius",
                alibaba: "Alibaba",
                xiaomi: "Xiaomi",
                sambanova: "SambaNova",
                moonshot: "Moonshot",
                minimax: "Minimax",
                nvidia: "NVIDIA",
            };
            return providerNames[provider] || provider;
        },
        openOpenRouterModelsModal(channel) {
            this.loadingModelsChannelId = channel._id;
            this.openRouterModelsChannel = channel;

            sendSocketMessage("user openrouter-list-models", {
                siteId: this.$store.state.site.site._id,
                userId: this.$store.state.auth.user._id,
                channelId: channel._id,
            });
        },
        handleOpenRouterModelsResult(data) {
            console.log("handleOpenRouterModelsResult",data)
            this.loadingModelsChannelId = null;
            if (data.success) {
                this.openRouterModels = data.models || [];
                this.openRouterModelsModal = true;
            } else {
                this.$message.error(data.message || "Model listesi alınamadı");
            }
        },
        copyModelId(modelId) {
            navigator.clipboard.writeText(modelId).then(() => {
                this.$message.success("Model ID kopyalandı");
            }).catch(() => {
                this.$message.error("Kopyalama başarısız");
            });
        },
        calculateTableHeight() {
            // Ekran yüksekliğine göre dinamik tablo yüksekliği hesapla
            const windowHeight = window.innerHeight;
            // Header (~100px) + search bar (~60px) + padding (~80px) = ~240px
            this.tableHeight = windowHeight - 280;
        },
    },
    watch: {
        site: {
            handler(newSite) {
                if (newSite && newSite._id) {
                    if (this.activeTab === "voiceAgents" && this.voiceAgents.length === 0) {
                        this.loadVoiceAgents();
                    }
                }
            },
            immediate: false,
        },
    },
    mounted() {
        this.loadData();
        this.calculateTableHeight();
        window.addEventListener("resize", this.calculateTableHeight);

        this.socketSubscription = socketMessageStream.subscribe((message) => {
            if (message.cmd === "openrouter_list_models_result") {
                this.handleOpenRouterModelsResult(message.data);
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.calculateTableHeight);
        if (this.socketSubscription) {
            this.socketSubscription.unsubscribe();
        }
    },
};
</script>

<style lang="scss" scoped>
.id-finder-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;
    background-color: #f9f9f9;

    .site-id-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
        background-color: #f0f5ff;
        border-radius: 6px;
        padding: 10px 15px;
        border-left: 3px solid #1890ff;

        .search-section {
            flex: 1;
            max-width: 400px;

            .search-input {
                width: 100%;
            }
        }

        .site-id-container {
            display: flex;
            align-items: center;

            .site-id-label {
                font-weight: bold;
                margin-right: 10px;
                color: #333;
            }

            .site-id-value {
                font-family: monospace;
                background-color: #fff;
                padding: 5px 10px;
                border-radius: 4px;
                cursor: pointer;
                display: flex;
                align-items: center;
                border: 1px solid #e8e8e8;

                &:hover {
                    background-color: #f5f5f5;
                }

                .anticon {
                    margin-left: 8px;
                    color: #1890ff;
                }
            }
        }
    }

    .id-finder-content {
        display: flex;
        flex: 1;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        background-color: white;

        .sidebar-menu {
            width: 250px;
            background-color: #fafafa;
            border-right: 1px solid #f0f0f0;

            .menu-items {
                padding: 10px 0;

                .menu-item {
                    display: flex;
                    align-items: center;
                    padding: 10px 15px;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        background-color: #f0f5ff;
                    }

                    &.active {
                        background-color: #e6f7ff;
                        border-right: 3px solid #1890ff;
                        font-weight: bold;
                    }

                    .menu-icon {
                        margin-right: 10px;
                        font-size: 20px;
                    }
                }
            }
        }

        .content-area {
            flex: 1;
            display: flex;
            flex-direction: column;

            .tab-content {
                flex: 1;
                padding: 15px;
                overflow: auto;

                .table-container {
                    background-color: white;
                    border-radius: 8px;
                    overflow: hidden;
                }

                .whatsapp-filter {
                    margin-bottom: 15px;

                    .channel-select {
                        width: 100%;
                    }
                }

                .table-field-filter {
                    margin-bottom: 15px;

                    .table-select {
                        width: 100%;
                    }
                }

                .color-indicator {
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    display: inline-block;
                }

                .integration-tags {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 5px;
                }
            }
        }
    }

    .openrouter-models-modal {
        .models-info {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 15px;

            .models-count {
                color: #666;
                font-size: 13px;
            }
        }
    }
}
</style>
